module.exports = __webpack_public_path__ + "img/homeb.9ba9e20a.png";